"use strict";

module.exports = require("./is-implemented")() ? String.prototype.contains : require("./shim");



//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/es5-ext/string/#/contains/index.js
// module id = ../../../../es5-ext/string/#/contains/index.js
// module chunks = 4